import { make } from 'vuex-pathify'

const state = {
  navActive: false,
  notifications: null,
  messages: null,
  mainScrollCont: null
}
const getters = make.getters(state)
const actions = make.actions(state)
const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
